<!-- Header -->
<div style="position: relative">

<h4 *ngIf="showHeader">
    {{header ? header : 'Forsendelser'}}
    <span class="badge  text-bg-secondary" style="vertical-align: 1px;">{{shipments.length}}</span>
</h4>

<div class="row" style="background-color: rgb(230, 230, 230); color: rgb(143, 143, 143);">
    <div class="col-1"></div>
    <div class="col-1">
        <ng-container *ngIf="shipmentRoute?.trip">
            Tur {{ shipmentRoute?.trip }}
            <span class="me-1 text-white badge rounded-pill text-bg-secondary">{{ shipments.length }}</span>
        </ng-container>
        <button *ngIf="enableTempSorting" (click)="changeSort('nota_number')" class="btn-sm btn btn-link p-0"><i class="fa fa-sort"></i> Notanummer</button>
    </div>
    <div class="col-1">
        <button *ngIf="enableTempSorting" (click)="changeSort('order_reference')" class="btn-sm btn btn-link p-0"><i
                class="fa fa-sort"></i> Weborder
        </button>
    </div>
    <ng-container *ngIf="showDate">
        <div class="col-1">
            <button *ngIf="enableTempSorting" (click)="changeSort('order_date')" class="btn-sm btn btn-link p-0"><i
                    class="fa fa-sort"></i> Ordre.
            </button>
        </div>
        <div class="col-1">
            <button *ngIf="enableTempSorting" (click)="changeSort('shipping_date')" class="btn-sm btn btn-link p-0"><i
                    class="fa fa-sort"></i> Lev.
            </button>
        </div>
    </ng-container>
    <div class="col-3"><b>Kundenavn</b><br>Leveringsadresse</div>
    <div class="col-1">
        <button *ngIf="enableTempSorting" (click)="changeSortNested('shipment_address.postal_code_receiver')"
                class="btn-sm btn btn-link p-0"><i class="fa fa-sort"></i> <b>PostNr</b>
        </button>
    </div>
    <div class="col-4 d-flex flex-row" *ngIf="showTraficLights">
    <div  style="width: 22px; font-size: 0.7rem;display: block">ViL</div>
    <div  style="width: 22px; font-size: 0.7rem;display: block">BF</div>
    <div  style="width: 22px; font-size: 0.7rem;display: block">BL</div>
    <div  style="width: 22px; font-size: 0.7rem;display: block">AK</div>
    <div  style="width: 22px; font-size: 0.7rem;display: block">KtP</div>
    <div  style="width: 22px; font-size: 0.7rem;display: block">Lev</div>
    <div  style="width: 22px; font-size: 0.7rem;display: block">SiK</div>
    </div>
    <div class="col-5  text-end  text-muted">{{ saving ? 'Gemmer...' : '' }}</div>
</div>

<style>
    .opacity-25 {
        pointer-events: none;
        opacity: 0.4;
    }
</style>


<!-- List -->
<div [ngClass]="{ 'opacity-25': saving }"

     dragula="contents"
     [(dragulaModel)]="shipments" (dragulaModelChange)="saveTableOrder2($event)"

     class="max-height: 500px; overflow-x: hidden; overflow-y: scroll">
    <ng-container *ngIf="shipments.length === 0">

            <div class="row">
                <div class="col-12" style="padding-top: 2px;">
                    <span class="text-muted" i18n>No shipments</span>
                </div>
            </div>
    </ng-container>
    <ng-template ngFor let-shipment [ngForOf]="shipments">
            <div class="row border-bottom striped">
                <div class="col-1" style="padding-top: 2px;">
                    <div class="float-left d-flex flex-column" style="gap: 0.3rem">
                        <app-shipment-status-widget [status]="shipment.shipment_status"
                                                    [label]="shipment.formattedStatus()"
                                                    *ngIf="!shipment.product_line_status"
                        ></app-shipment-status-widget>
                        <div style="width: 20px;height: 20px; margin-right: 0.5rem" *ngIf="shipment.product_line_status">
                            <i class="fas fa-exclamation-triangle text-warning"
                               [ngbTooltip]="shipment?.product_line_status_formatted" [container]="'body'"></i>

                        </div>
                        <div *ngIf="shipment.shipment_priority">
                            <i class="fas fa-star text-success" [ngbTooltip]="'Prioritet'"></i>
                        </div> <div *ngIf="shipment.is_protected">
                            <i class="fas fa-lock text-success" [ngbTooltip]="'Låst'"></i>
                        </div>
                    </div>
                </div>
                <div class="col-1" style="padding-top: 2px;">
                    <div class="ps-1 float-left">
                        <!--<span *ngIf="shipment.nota_number" class="badge  text-bg-secondary me-1" style="vertical-align: 1px;">nota</span>-->
                        <a href="javascript:" (click)="edit(shipment)">{{shipment.nota_number }}</a>

                        <a [routerLink]="'/shipment/' + shipment.id" class="text-info" style="cursor: pointer;" target="_blank"><i class="fas fa-link"></i></a>
                        <span class="badge  text-bg-info ms-2" *ngIf="showDate">{{shipment.branch}}</span>
                    </div>
                </div>
                <div class="col-1" style="padding-top: 2px;">
                    <!--<span *ngIf="shipment.order_reference" class="badge  text-bg-secondary me-1" style="vertical-align: 1px;">web</span>-->
                    <a href="javascript:" (click)="edit(shipment)">{{shipment.order_reference }}</a>
                </div>
                <ng-container *ngIf="showDate">
                    <div class="col-1">
                        <span>
                            <small>{{shipment.formattedDate('order_date', 'DD.MM.YY')}}</small>
                            <!--
                            <span class="badge  text-bg-success">
                                <i class="fas fa-calendar-alt"></i> {{shipment.formattedDate('order_date', 'DD.MM.YY')}}
                            </span>
                            -->
                        </span>
                    </div>
                    <div class="col-1">
                        <span>
                            <small>{{shipment.formattedDate('shipping_date', 'DD.MM.YY')}}</small>
                            <!--
                            <span class="badge  text-bg-success">
                                <i class="fas fa-calendar-alt"></i> {{shipment.formattedDate('shipping_date', 'DD.MM.YY')}}
                            </span>
                            -->
                        </span>
                    </div>
                </ng-container>
                <div class="col-3" >
                    <span [ngClass]="{'text-danger':shipment?.has_invalid_coords}">
                    <app-shipment-address
                            *ngIf="!shipment.isReturnShipment()"
                            [address]="shipment?.shipment_address" [minimal]="true"></app-shipment-address>
                    <app-shipment-address   *ngIf="shipment.isReturnShipment()" [address]="shipment?.sender_address" [minimal]="true"
                                          [label]="'Afsender Adresse'"></app-shipment-address>
                    </span>
                    <ng-container *ngIf="shipment?.has_invalid_coords"><br/><button (click)="edit(shipment, true)" class="btn btn-sm btn-warning mb-1">Ret adresse</button></ng-container>
                </div>
                <div class="col-1">
                    <strong>{{ shipment.isReturnShipment() ? shipment?.sender_address?.postal_code_receiver : shipment?.shipment_address?.postal_code_receiver }}</strong>
                </div>
                <div class="col-4" *ngIf="showTraficLights">
                <div><app-shipment-status-widget [active]="ShipmentsService.getBit(shipment.delivery_progress, shipmentsService.deliveryBitMasks.ikkePaaLager)" [status]="'not_in_stock'" [label]="'Ikke på lager'" [showLabel]="false" [shouldBeInline]="true"></app-shipment-status-widget></div>
                <div><app-shipment-status-widget [active]="ShipmentsService.getBit(shipment.delivery_progress, shipmentsService.deliveryBitMasks.bestiltFjernlager)" [status]="'ordered_remote'" [label]="'Bestilt Fjernlager'" [showLabel]="false" [shouldBeInline]="true"></app-shipment-status-widget></div>
                <div><app-shipment-status-widget [active]="ShipmentsService.getBit(shipment.delivery_progress, shipmentsService.deliveryBitMasks.bestiltLeverandoer)" [status]="'ordered_supplier'" [label]="'Bestilt leverandør'" [showLabel]="false" [shouldBeInline]="true"></app-shipment-status-widget></div>
                <div><app-shipment-status-widget [active]="ShipmentsService.getBit(shipment.delivery_progress, shipmentsService.deliveryBitMasks.ankommet)" [status]="'packing_started'" [label]="'Ankommet'" [showLabel]="false" [shouldBeInline]="true"></app-shipment-status-widget></div>
                <div><app-shipment-status-widget [active]="ShipmentsService.getBit(shipment.delivery_progress, shipmentsService.deliveryBitMasks.lagervare)" [status]="'packing_started'" [label]="'Lagervare'" [showLabel]="false" [shouldBeInline]="true"></app-shipment-status-widget></div>
                <div><app-shipment-status-widget [active]="ShipmentsService.getBit(shipment.delivery_progress, shipmentsService.deliveryBitMasks.modtagetAfKunde)" [status]="'complete'" [label]="'Modtaget af kunde'" [showLabel]="false" [shouldBeInline]="true"></app-shipment-status-widget></div>
                <div><app-shipment-status-widget [active]="ShipmentsService.getBit(shipment.delivery_progress, shipmentsService.deliveryBitMasks.slaaetIKassen)" [status]="'complete'" [label]="'Slået i kassen'" [showLabel]="false" [shouldBeInline]="true"></app-shipment-status-widget></div>
                     </div>
                <div class="col-5  text-end" [ngClass]="{'col-3':showDate, 'col-5':!showDate}">
                    <span class="text-nowrap d-flex align-items-center">
                        <ng-container>
                            <i *ngIf="shipment.comments" class="fas fa-comment" ngbTooltip="{{ shipment.comments }}"></i>
                            <i *ngIf="!shipment.comments" class="fas fa-comment" style="opacity: 0.25;"></i>
                        </ng-container>
                            <button href="javascript:"
                                    [container]="'body'"
                                    [ngbPopover]="sortpopContent"
                                    [placement]="['bottom', 'left']" [autoClose]="'outside'" [triggers]="'manual'"
                                    #p="ngbPopover"
                                    (click)="shipmentsService?.paintData?.active ? applyPaint(shipment) : p.open()"
                                                                class="text-white btn btn-sm btn-link">
                            <span class="me-1 text-white badge rounded-pill text-bg-secondary"
                                  [ngStyle]="{'background-color': shipment?.shipment_route?.route_color, 'width': '40px'}">
                                {{shipment?.shipment_route?.driver_initials}}
                                - {{shipment?.shipment_route?.trip}}
                            </span>
                            </button>

                            <ng-template #sortpopContent>
                          <div class="form-group">
                            <label i18n>Change delivery date</label>

                            <app-date-time-picker [(date)]="shipment.shipping_date"
                                                  [options]="{calendarWeeks:true, format: 'DD-MM-YYYY'}"
                                                  [inputSmall]="true"
                                                  id="shipment-shipping-date"
                                                  type="text"
                                                  name="shipment-shipping-date"></app-date-time-picker>
                            </div>

                            <div class="form-group">

                            <label i18n>Change route</label>
                                                        <select class="form-control  form-control-sm"
                                                                name="shipment-route-id"
                                                                [(ngModel)]="shipment.shipment_route_id"

                                                                [disabled]="saving">
                                                <option i18n [value]="null">No Driver assigned</option>
                                                <ng-template ngFor let-shipmentRoute [ngForOf]="shipmentRoutes">
                                                    <option [value]="shipmentRoute.id">{{ shipmentRoute.name }} {{ shipmentRoute.trip }}
                                                        ({{ shipmentRoute.branch }})
                                                    </option>
                                                    </ng-template>
                                            </select>
                            </div>

                            <div class="form-group">
                            <button (click)="updateShipment(shipment, p)">Gem ændringer</button>
                            </div>
                        </ng-template>


                         <app-shipment-status-widget
                                 [variant]="true"
                                 [label]="shipment.productLinesStatusLabel()"
                                 [color]="shipment.productLinesStatusColor()"></app-shipment-status-widget>

<!--                        <button (click)="printSingle(shipment)" class="btn btn-link"><i-->
<!--                                class="fas fa-print"></i></button>-->

                        <span (click)="edit(shipment)" class="text-info me-1" style="cursor: pointer;">
                            <ng-template #popTitle><span i18n>Info</span></ng-template>
                            <ng-template #popContent>

                                <p class="font-weight-bold" i18n>Events</p>
                                <span i18n class="text-info" *ngIf="!shipment.shipment_events || shipment.shipment_events.length === 0">No events for shipment</span>
                                <table class="table  table-sm table-condensed"
                                       *ngIf="shipment.shipment_events && shipment.shipment_events.length >0">
                                    <thead>
                                        <tr>
                                            <th>Besked</th>
                                            <th>Tidspunkt</th>
                                            <th>Billede</th>
                                            <th></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <ng-template ngFor let-shipmentEvent [ngForOf]="shipment.shipment_events">
                                            <tr>
                                                <td>{{ shipmentEvent.status_text }}</td>
                                                <td>{{ shipmentEvent.date.format('DD-MM-YYYY HH:mm') }}</td>
                                                <td>

                                                    <ng-container
                                                            *ngIf="shipmentEvent.image_links && shipmentEvent.image_links.length > 0">
                                                        <i class="fas fa-camera"></i>&nbsp;({{shipmentEvent.image_links.length}}
                                                        )
                                                    </ng-container>
                                                </td>
                                                <td>
                                                    <span
                                                            *ngIf="shipmentEvent.x && shipmentEvent.y"><i
                                                            class="fas fa-map-pin"></i></span></td>
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </table>

                                <hr/>

                                <p class="font-weight-bold">{{ shipment.shipment_address.adress_1_receiver }}
                                    , {{ shipment.shipment_address.postal_code_receiver }}</p>

                                <table class="table  table-sm">
                                    <tr *ngFor="let shipmentProductLine of shipment.shipment_product_lines">
                                        <td>{{ shipmentProductLine.product_number }}</td>
                                        <td>{{ shipmentProductLine.shipment_status_formatted }}<span *ngIf="shipmentProductLine.purchase_order"><small> - {{shipmentProductLine.purchase_order}}</small></span> </td>
                                        <td>{{ shipmentProductLine.product_text_1 }}</td>
                                        <td class="text-end">{{ shipmentProductLine.amount + ' ' + shipmentProductLine.unit }}</td>
                                    </tr>
                                </table>
                            </ng-template>

                            <i class="fas fa-info-circle" popoverClass="popover--shipment" [popoverTitle]="popTitle"
                               [container]="'body'"
                               [ngbPopover]="popContent" [placement]="['bottom', 'left']"></i>
                        </span>

                        <span class="d-flex flex-column mx-2 align-items-center justify-content-between">
                            <img [src]="environment.assetBase +'/assets/img/'+shipment.carrier_logo" class="img-fluid" style="width: 25px; height: auto;">
                            <small style="font-size: 10px">{{shipment.carrier}}</small>
                        </span>
                        <!--                        <span (click)="events(shipment)" class="text-info  me-3  ms-3" style="cursor: pointer;">-->
                        <!--                            <ng-template #popEventsTitle><span i18n>Events</span></ng-template>-->
                        <!--                            <ng-template #popEventsContent>-->
                        <!--                                -->
                        <!--                            </ng-template>-->

                        <!--                            <i class="fas fa-exclamation-circle" popoverClass="popover&#45;&#45;shipment" [popoverTitle]="popEventsTitle" [ngbPopover]="popEventsContent" [placement]="['bottom', 'left']"></i>-->
                        <!--                        </span>-->

                        <span class="d-flex flex-column justify-content-start align-items-start" style="font-size: 10px">
                            <small *ngFor="let shipmentPackage of shipment.shipment_packages">
                                {{shipmentPackage.package_type}} {{shipmentPackage.weight ? (shipmentPackage.weight | number:'1.2-2') + ' kg' : '-'}} {{shipmentPackage.price ? (shipmentPackage.price | currency : 'DKK') : '-'}}
                            </small>
                        </span>

                        <fa-icon [icon]="faArrowRotateBack" *ngIf="shipment.isReturnShipment()"></fa-icon>

                        <span class="ms-auto"><i class="fas fa-grip-lines"></i></span>
                    </span>

                    <span class="text-nowrap d-flex align-items-center" [ngClass]="{'text-warning': shipment.weight_warning}">
                            <i class="fa-solid fa-weight-hanging"></i>&nbsp;{{ shipment.weight_sum | number:'1.2-2':'da'}} kg
                        </span>
                    <span class="text-nowrap d-flex align-items-center">
                        <i class="fa-solid fa-barcode-read"></i>&nbsp;{{shipment?.shipment_product_lines?.length}}
                        </span>
                </div>

                <div class="p-2 mt-2" *ngIf="expandOrderLines">
                    <table class="table  table-sm">
                        <thead>
                        <tr>
                            <th></th>
                            <th>#</th>
                            <th>Status</th>
                            <th i18n>Stock (Reserved)</th>
                            <th>PO#</th>
                            <th>Note</th>
                            <th>TUN</th>
                            <th>Produkt tekst</th>
                            <th class="text-end">Antal</th>
                            <th class="text-end">Vægt</th>
                        </tr>
                        </thead>
                        <tbody>

                        <ng-template ngFor let-product_line [ngForOf]="shipment.shipment_product_lines" let-i="index">
                            <tr app-shipment-product-line [shipment]="shipment" [product_line]="product_line" [i]="i"></tr>
                        </ng-template>
                        </tbody>
                    </table>

                    <button class="btn btm-sm btn-primary mt-2 mb-2" (click)="updateShipment(shipment)"
                            *ngIf="expandOrderLines">Save
                    </button>
                </div>
            </div>
    </ng-template>
</div>

<!-- Buttons -->
<div class="mt-3 clearfix d-flex justify-content-end" *ngIf="shipments">
    <!--    <button class="btn  btn-sm  btn-link">Print <i class="fas fa-print"></i></button>-->
    <button class="btn btm-sm btn-primary me-3 me-auto" (click)="updateStock()" *ngIf="expandOrderLines" i18n>Update
        stock
    </button>
    <ng-container *ngIf="shipmentRoute">
        <button (click)="printRoute()" class="btn  btn-sm  btn-primary  clearfix ms-2" [disabled]="optimizingRoute">{{ optimizingRoute ? 'Printer...' : 'Print rute'  }}</button>
        <button
                [ngbTooltip]="!canOptimize() ? 'Kan ikke optimere rute med under 1 eller over 10 punkter' : ''"
                [container]="'body'"
                (click)="optimizeRoute()" class="btn  btn-sm  btn-primary  clearfix ms-2"
                [disabled]="optimizingRoute || !canOptimize()">{{ optimizingRoute ? 'Beregner...' : 'Beregn optimal rute' }}
            <i class="fas fa-exclamation-triangle text-danger" *ngIf="!canOptimize()"></i>
        </button>

        <button
                [ngbTooltip]="!canOptimize() ? 'Kan ikke optimere rute med under 1 eller over 10 punkter' : ''"
                [container]="'body'"
                (click)="exportGpx()" class="btn  btn-sm  btn-primary  clearfix ms-2"
                [disabled]="optimizingRoute || !canOptimize()">{{ optimizingRoute ? 'Beregner...' : 'Export GPX' }}
            <i class="fas fa-exclamation-triangle text-danger" *ngIf="!canOptimize()"></i>
        </button>

        <button (click)="reverseRoute()" class="btn  btn-sm  btn-primary  clearfix ms-2" [disabled]="optimizingRoute">{{ optimizingRoute ? 'Beregner...' : 'Vend rute'  }}</button>
        <!--        <button *ngIf="shipments.length > 0 && !isAllReady()" class="btn  btn-sm  btn-primary clearfix ms-2" (click)="markReady()">Klar til levering</button>-->
        <!--        <button *ngIf="shipments.length > 0 && isAllReady()" class="btn  btn-sm  btn-primary  clearfix ms-2" (click)="showRoute()">Vis rute</button>-->
        <button *ngIf="shipments.length > 0" class="btn  btn-sm  btn-primary  clearfix ms-2" (click)="showRoute()">Vis rute</button>


        <button
                [ngbTooltip]="!canOptimize() ? 'Kan ikke optimere rute med under 1 eller over 10 punkter' : ''"
                [container]="'body'"
                (click)="startRoute()" class="btn  btn-sm  btn-primary  clearfix ms-2"
                [disabled]="optimizingRoute || !canOptimize()">{{ optimizingRoute ? 'Beregner...' : 'Starter Rute' }}
            <i class="fas fa-exclamation-triangle text-danger" *ngIf="!canOptimize()"></i>
        </button>
    </ng-container>
</div>
</div>
